import React from 'react';

import type { TabIconProps } from './TabIcon.types';
import { TAB_ICON_PATHS } from './tabIconPaths';

/** Web tab icon — SVG counterpart to iOS SF Symbols in tabIconConfig. */
export function TabIcon({ name, color, focused = false, size = 22 }: TabIconProps) {
  const paths = TAB_ICON_PATHS[name];
  const d = focused ? paths.filled : paths.outline;
  const strokeOnly = name === 'wealth' || !focused;

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden style={{ display: 'block' }}>
      <path
        d={d}
        fill={strokeOnly ? 'none' : color}
        stroke={strokeOnly ? color : 'none'}
        strokeWidth={focused ? 2 : 1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
